import React, { KeyboardEvent } from "react";
import { actionCreators, State } from "@App/state";
import { bindActionCreators } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";

type KeyNumberSelectionProps = {
  handleKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
};

export const KeyNumberSelection = React.memo<KeyNumberSelectionProps>(
  (props: KeyNumberSelectionProps) => {
    const key = useSelector((state: State) => state.orders.key);

    const dispatch = useDispatch();
    const { setKey } = bindActionCreators(actionCreators, dispatch);

    return (
      <div className="md:w-1/3 flex gap-3">
        <input
          type="text"
          className="w-full p-3 border border-neutral-500 rounded-md"
          placeholder="HSN"
          value={key.hsn}
          onChange={({ target }) => setKey({ ...key, hsn: target.value.toUpperCase() })}
          autoFocus
        />
        <input
          type="text"
          className="w-full p-3 border border-neutral-500 rounded-md"
          placeholder="TSN"
          value={key.tsn}
          onChange={({ target }) => setKey({ ...key, tsn: target.value.toUpperCase() })}
          onKeyDown={props.handleKeyDown}
        />
      </div>
    );
  },
);
